"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportBase = void 0;
var tslib_1 = require("tslib");
var pdfTheme_1 = require("../pdfTheme");
/*
Note:
The pdfmake library has limited styling functionality and is still missing some fairly important features.
As of the current version (v0.2.9), the library does not support vertically aligned text out of the box.
There is a work around if feature this is necessary in the future, but has not been included here.
You can read more about it here: https://github.com/bpampuch/pdfmake/issues/74#issuecomment-1872332430
*/
/**
 * The base class for all reports using the PDFMake library
 * Documentation can be found here: https://pdfmake.github.io/docs/0.1/
 */
var ReportBase = /** @class */ (function () {
    function ReportBase(poles) {
        /**
         * The poles to be included in the report
         */
        this.poles = [];
        this.images = {};
        this.nodes = [];
        this.poles = poles;
        this.buildPDF();
    }
    /**
     * Export the PDF to be used by the PDFMake library
     */
    ReportBase.prototype.export = function () {
        var nodeTypeStyles = [];
        var nodeTypePatterns = [];
        var nodeContent = [];
        // Fetch the styles of each node, and the nodes that they use
        var fetchStyles = function (node) {
            var _a;
            (_a = node.nodes) === null || _a === void 0 ? void 0 : _a.forEach(function (deeperNode) { return fetchStyles(deeperNode); });
            if (node.exportStyles &&
                !nodeTypeStyles.some(function (x) { return x.constructor.name === node.constructor.name; })) {
                nodeTypeStyles.push(node);
            }
        };
        // Fetch the patterns of each node, and the nodes that they use
        var fetchPatterns = function (node) {
            var _a;
            (_a = node.nodes) === null || _a === void 0 ? void 0 : _a.forEach(function (deeperNode) { return fetchPatterns(deeperNode); });
            if (node.exportPatterns &&
                !nodeTypePatterns.some(function (x) { return x.constructor.name === node.constructor.name; })) {
                nodeTypePatterns.push(node);
            }
        };
        // Fetch the styles and content of each node
        this.nodes.forEach(function (node) {
            fetchStyles(node);
            fetchPatterns(node);
            nodeContent.push(node.exportContent());
        });
        return {
            pageSize: pdfTheme_1.pdfTheme.page.size,
            // setting pageMargins to '0' causes issues because pdfmake does falsey checks on its value
            // so set it to an array of 0s instead
            pageMargins: [0, 0],
            content: nodeContent,
            images: this.images,
            styles: nodeTypeStyles.reduce(function (styles, node) { return (tslib_1.__assign(tslib_1.__assign({}, styles), node.exportStyles())); }, {}),
            patterns: nodeTypePatterns.reduce(function (patterns, node) { return (tslib_1.__assign(tslib_1.__assign({}, patterns), node.exportPatterns())); }, {})
        };
    };
    return ReportBase;
}());
exports.ReportBase = ReportBase;
//# sourceMappingURL=ReportBase.js.map